module.exports = __webpack_public_path__ + "3978926f738b0dceab9b50071ba95eb0.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/humble-bundle-logo-only.png
// module id = 385
// module chunks = 0